import { Button, notification } from "antd";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from "@ant-design/icons";

notification.config({
  placement: "topRight",
  top: window.innerWidth < 768 ? 110 : 70,
  duration: 3.5,
  maxCount: 3,
});

const ICONS = {
  success: <CheckCircleFilled style={{ color: "#52c41a" }} />,
  error: <CloseCircleFilled style={{ color: "#ff4d4f" }} />,
  warning: <ExclamationCircleFilled style={{ color: "#faad14" }} />,
  info: <InfoCircleFilled style={{ color: "#1677ff" }} />,
};

const TITLES = {
  success: "Success",
  error: "Error",
  warning: "Warning",
  info: "Notice",
};

type ToastType = "success" | "error" | "warning" | "info";

let toastCounter = 0;

/**
 * Simple toast — auto-dismisses on its own after 3.5s, no button, no
 * user interaction needed. Use for routine success/error feedback.
 */
export const toast = (type: ToastType, description: string, title?: string) => {
  notification[type]({
    message: title || TITLES[type],
    description,
    icon: ICONS[type],
    className: `app-toast app-toast-${type}`,
  });
};

/**
 * Toast with an "OK" button — auto-dismisses after 5s if untouched, but
 * closes immediately if the user taps OK. Use for messages worth making
 * sure the user actually saw (e.g. important warnings, confirmations).
 */
export const toastConfirm = (type: ToastType, description: string, title?: string) => {
  notification[type]({
    message: title || TITLES[type],
    description,
    icon: ICONS[type],
    className: `app-toast app-toast-${type}`,
    duration: 5,
    btn: (
      <Button
        type="primary"
        size="small"
        onClick={() => notification.destroy()}
      >
        OK
      </Button>
    ),
  });
};